module.exports = __webpack_public_path__ + "img/OnArchitecture3.d16dd1c7.jpg";